var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.77 25.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #1e2224;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.4,19.49l1.05-2.45,2.55,2.55-.84,1.72c-.08.16-.19.31-.32.44l-3.16,3.08c-.62.6-1.61.59-2.22-.01-.62-.62-.63-1.63,0-2.25l2.6-2.57c.14-.14.26-.31.34-.5h0ZM4.64,10.55l1.31-.52-.9,4.08c-.05.24.01.5.17.68v.02s2.65,2.98,2.65,2.98v.03s0-.02,0-.02l1.62,2.19c.12.16.21.35.26.55l.91,3.54c.22.85,1.1,1.36,1.95,1.13.83-.22,1.34-1.08,1.13-1.91l-1.05-4.21c-.05-.22-.16-.43-.3-.6l-2.69-3.37.83-3.25.48,1.27c.1.28.29.52.52.7l1.68,1.27c.69.53,1.68.39,2.21-.3.53-.69.4-1.69-.3-2.22l-1.24-.95c-.22-.17-.4-.4-.5-.66l-1.07-2.61c-.14-.34-.39-.6-.69-.75h0s-1.27-.87-2.2-1.12c-.97-.26-2.5-.1-2.68-.08-.19,0-.39.03-.59.11l-3.6,1.42c-.09.03-.16.09-.21.16l-1.64,2.18c-.52.7-.38,1.69.31,2.21.7.53,1.69.39,2.22-.31l1.05-1.4c.09-.12.2-.21.34-.26h0ZM9.86,5.54c1.53,0,2.77-1.24,2.77-2.77s-1.24-2.77-2.77-2.77-2.77,1.24-2.77,2.77,1.24,2.77,2.77,2.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.9cf3cda12a6e40cded6ee8c3e2a80910.svg";
export { ForwardRef as ReactComponent };